import { required, email, min, max,regex,confirmed, length, numeric,digits,is, min_value, max_value, } from "vee-validate/dist/rules";
import { extend } from "vee-validate";

extend("required", {
  ...required,
  message: "This field is required"
});

extend("max", {
    ...max,
    message: "This field must not be more than {length} characters"
  });

extend("min", {
  ...min,
  message: "This field must not be less than {length} characters"
});

extend("email", {
  ...email,
  message: "This field must be a valid email"
});

extend("regex",{...regex})
extend("confirmed",{...confirmed, message:"The fields do not match!"})
extend("length",{...length, message:"The field must be exaclty {length} characters"})
extend("numeric",{...numeric})
extend("digits",{...digits})
extend("is",{...is})
extend("min_value", {...min_value, message: "Please enter a larger number"});
extend("max_value", {...max_value, message: "Please enter a smaller number"});
